<template>
  <a-config-provider :locale="locale">
    <layout />
  </a-config-provider>
</template>

<script>
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'

import bootstrap from '@/composables/bootstrap'
import useGuide from '@/composables/use-guide'
import Layout from '@/layout/Index'

export default {
  name: 'App',
  components: {
    Layout
  },
  setup () {
    bootstrap()

    const store = useStore()
    const { getLocaleMessage } = useI18n()
    const { showNewVersion } = useGuide()

    const locale = computed(() => getLocaleMessage(store.getters.lang).antLocale)

    onMounted(showNewVersion)

    return {
      locale
    }
  }
}
</script>
